// extracted by mini-css-extract-plugin
export default {"services":"subscriptions_services__6TMc8"};